export default __webpack_public_path__ + "static/media/07-Mastercard-BlackLogo.ab155827.jpg";